import { render, staticRenderFns } from "./DropdownForm.vue?vue&type=template&id=128bf45a&"
import script from "./DropdownForm.vue?vue&type=script&lang=ts&"
export * from "./DropdownForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports